import JsonDeloop from "../lib/json-deloop.js";
import JsonAutoDate from "../lib/json-auto-date.js";
import Thread from "../lib/thread.js";
import TokenStorage from "./token-storage.js";
import auth from "../remotes/auth.js";
import Vue from "./project-vue.js";


const redirectLogin = () => {
    window.location.href = "login.html?redirect-url=" + encodeURIComponent(window.location.href);
};

let tokenRefreshing = false;

const refreshToken = async (token) => {
    let result = await auth.refreshToken(token.refreshToken);
    if (!result.success) {
        console.error(result.msg);
        redirectLogin();
        return;
    }
    return result.data;
};

let token = null;
const autoAuth = async config => {
    if (!token) {
        token = TokenStorage.load();
    }
    // 认证判定
    if (!config.public) {
        while (tokenRefreshing) { // 自旋锁
            console.info("自旋锁 " + new Date());
            await Thread.sleep(10);
        }
        
        if (!token) {
            redirectLogin();
            return config;
        }
        let now = new Date().getTime();
        if (token.expireTime && token.expireTime <= now + 60 * 1000) { // accessToken过期
            if (token.refreshExpireTime && token.refreshExpireTime <= now + 60 * 1000) { // refreshToken过期
                console.info("token都过期");
                redirectLogin();
                return config;
            } else {
                console.debug("pre refreshToken");
                tokenRefreshing = true;
                token = await refreshToken(token);
                token = TokenStorage.save(token);
                tokenRefreshing = false;
            }
        }
    }
    if (token && token.accessToken && !config?.headers?.Token) {
        config.headers.Token = token.accessToken;
    }
    return config;
};

const formatData = async config => {
    if (config.data) {
        config.data = JsonAutoDate.format(config.data);
    }
    if (config.params) {
        config.params = JsonAutoDate.format(config.params);
    }
    
    return config;
};

const parseResponse = response => {
    if (response.status != 200) {
        console.error(response.statusText);
        alert("系统错误，请稍后重试");
        return null;
    }
    let result = response.data;
    result = JsonAutoDate.parse(result);
    result = JsonDeloop.parse(result);
    return result;
};

const autoResult = async (result, config) => {
    if (!config?.autoResult) {
        return result;
    }
    if (!result.success) {
        await Vue.prototype.$alertError(result.msg);    
        throw new Error(result.msg);
    }
    
    if (result.page) {
        return result;
    } else {
        return result.data;
    }
};

const processError = async error => {
    if (error.response) {
        switch (error.response.status) {
        case 401:
            window.location.href = "login.html?redirect-url=" + encodeURIComponent(window.location.href);
            break;
        case 403:
            await Vue.prototype.$alertError("无权限");
            break;
        case 500:
        case 502:
            await Vue.prototype.$alertError("系统错误，请联系管理员");
            break;
        case 503:
            await Vue.prototype.$alertError("您的请求太频繁了，请稍后重试");
            break;
        }
    } else if (error.request) {
        await Vue.prototype.$alertError("无网络");
    } else {
        await Vue.prototype.$alertError("未知异常，请联系管理员");
    }
    return Promise.reject(error);
};

export default {
    request: [
        autoAuth,
        formatData
    ],
    response: [
        parseResponse,
        autoResult
    ],
    error: [
        processError
    ]
};